/**
 * What went wrong, in the backend's words when it gave any. Axios' own
 * "Request failed with status code 400" says nothing a person can act on.
 */
export const errorText = (
   e: unknown,
   fallback = 'Something went wrong. Your changes are still here; try again.'
): string => {
   const err = e as {
      message?: string
      response?: {
         status?: number
         data?: {
            message?: string
            errorMessages?: unknown
            error?: { message?: string }
         }
      }
      config?: { url?: string }
   }
   const data = err?.response?.data
   const list = Array.isArray(data?.errorMessages)
      ? data.errorMessages.map(String).filter(Boolean)
      : typeof data?.errorMessages === 'string' && data.errorMessages
        ? [data.errorMessages]
        : []
   const said = [data?.message, data?.error?.message, ...list].filter(
      (m) => m && !/^(bad request|internal server error)$/i.test(String(m))
   )
   if (said.length) return [...new Set(said.map(String))].join(' · ')
   if (data?.message) return String(data.message)
   const m = String(err?.message || '')
   const code = m.match(/^Request failed with status code (\d+)$/)
   if (code) {
      const path = String(err?.config?.url || '').replace(/^.*\/api\/v1/, '')
      return `The server answered ${code[1]}${path ? ` on ${path}` : ''}. Try again; if it keeps happening, send this line to support.`
   }
   return m || fallback
}
